import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { getTransactionValuesWidgetDataAction } from "./../../actions/DashboardActions";

class TransactionValuesWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMode: "month",
      responseData: {},
      chartOptions: {
        chart: {
          height: "315"
        },
        title: {
          text: ""
        },
        series: [
          {
            data: [],
            name: "Open Transactions Value"
          }
        ],
        xAxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          title: false
        },

        yAxis: {
          labels: {
            format: "{value}k"
          },
          title: false
        }
      }
    };
  }

  componentWillMount() {
    this.props.getTransactionValuesWidgetDataAction().then(res => {
      this.setState(
        {
          responseData: res
        },
        () => {
          this.changeView("month");
        }
      );
    }).catch(err => {
      /*if api fails then no need to update state*/
    });
  }

  getMonthNameByNumber(monthNumber) {
    let monthName = "";
    if (monthNumber == 1) {
      monthName = "January";
    }

    switch (monthNumber) {
      case 1:
        monthName = "January";
        break;
      case 2:
        monthName = "February";
        break;
      case 3:
        monthName = "March";
        break;
      case 4:
        monthName = "April";
        break;
      case 5:
        monthName = "May";
        break;
      case 6:
        monthName = "June";
        break;
      case 7:
        monthName = "July";
        break;
      case 8:
        monthName = "August";
        break;
      case 9:
        monthName = "September";
        break;
      case 10:
        monthName = "October";
        break;
      case 11:
        monthName = "November";
        break;
      case 12:
        monthName = "December";
        break;
    }
    return monthName;
  }

  /**
   * @desc change view and data according view to display
   * @param {*} view 
   */
  changeView(view) {
    var monthsLabels = (this.state.responseData.monthTransaction || [])
      .map(e => {
        return {
          label: this.getMonthNameByNumber(e._id.month),
          value: e.total,
          month: e._id.month,
          year: e._id.year
        };
      })
      // .sort((a, b) => {
      //   return a.month > b.month ? 1 : -1;
      // })
      .sort((a, b) => {
        if(a.year !== b.year){
          return a.year - b.year;
       }else{
          return a.month - b.month;
       };
      });

    var monthsCommission = (this.state.responseData.monthCommission || [])
      .map(e => {
        return {
          label: this.getMonthNameByNumber(e._id.month),
          value: e.total,
          month: e._id.month,
          year: e._id.year
        };
      })
      // .sort((a, b) => {
      //   return a.month > b.month ? 1 : -1;
      // });
      .sort((a, b) => {
        if(a.year !== b.year){
          return a.year - b.year;
       }else{
          return a.month - b.month;
       };
      });
     

    var weeks = [];
    Object.keys(this.state.responseData.weekTransaction || {}).forEach(k => {
      let total = 0;
      let totalComm = 0;
      this.state.responseData.weekTransaction[k].forEach(e => {
        total = total + Number(e.agreedOpenPrice);
        totalComm = totalComm + Number(e.Percentage);
      });
      weeks.push({ label: "Week" + k, value: total, commission: totalComm });
    });
    weeks.sort((a, b) => {
      return a.label > b.label ? 1 : -1;
    });
    if (view == "month") {
      this.setState({
        viewMode: "month",
        chartOptions: {
          chart: {
            height: "315"
          },
          title: {
            text: ""
          },
          series: [
            {
              data: monthsLabels.map(e => {
                return Number(e.value);
              }),
              name: "Open Transactions Value"
            },
            {
              data: monthsCommission.map(e => {
                return Number(e.value);
              }),
              name: "Commission"
            }
          ],
          xAxis: {
            categories: monthsLabels.map(e => {
              return e.label;
            }),
            title: false
          },

          yAxis: {
            labels: {
              formatter: function() {
                return this.value / 1000 + "k";
              }
            },
            title: {
              text: "Amount"
            }
          }
        }
      });
    } else {
      this.setState({
        viewMode: "week",
        chartOptions: {
          chart: {
            height: "315"
          },
          title: {
            text: ""
          },
          series: [
            {
              data: weeks.map(e => {
                return Number(e.value);
              }),
              name: "Open Transactions Value"
            },
            {
              data: weeks.map(e => {
                return Number(e.commission);
              }),
              name: "Commission"
            }
          ],
          xAxis: {
            categories: weeks.map(f => {
              return f.label;
            }),
            title: false
          },

          yAxis: {
            labels: {
              formatter: function() {
                return this.value / 1000 + "k";
              }
            },
            title: {
              text: "Amount"
            }
          }
        }
      });
    }
  }

  render() {
    return (
      <div>
        <Row>
          <Col>
            <h4 className="color-blue-3 font-16 font-600">
              Transactions Value
            </h4>
          </Col>
          <Col align="right" className="col-auto">
            <div className="switch-btns">
              <Button
                variant="primary"
                className={this.state.viewMode == "week" && "active"}
                onClick={() => {
                  this.changeView("week");
                }}
              >
                Week
              </Button>
              <Button
                variant="primary"
                className={this.state.viewMode == "month" && "active"}
                onClick={() => {
                  this.changeView("month");
                }}
              >
                Month
              </Button>
            </div>
          </Col>
        </Row>
        {this.state.chartOptions.series[0].data.length == 0 ? (
          <div className="dash-no-records">No Records Found</div>
        ) : (
          <div className="high-line">
            <HighchartsReact
              highcharts={Highcharts}
              options={this.state.chartOptions}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    valuesData: state.reducer.valuesData || {}
  };
};

export default connect(mapStateToProps, {
  getTransactionValuesWidgetDataAction
})(TransactionValuesWidget);
